export default __webpack_public_path__ + "static/media/DSC_7737.15ae8fd5.jpg";